import {BBModel} from "../bb_model";

const memberPurchase = {
    query(member, params) {
        if (!params) {
            params = {};
        }
        params.no_cache = true;
        return new Promise((resolve, reject) => {
            if (!member.$has('purchase_totals')) {
                reject('member does not have any purchases');
            } else {
                member.$get('purchase_totals', params).then((purchases) => {
                        params.no_cache = false;
                        return purchases.$get('purchase_totals', params).then((purchases) => {
                                purchases = Array.from(purchases).map(purchase =>
                                    new BBModel.PurchaseTotal(purchase));
                                return resolve(purchases);
                            }
                            , (err) => {
                                if (err.status === 404) {
                                    return resolve([]);
                                } else {
                                    return reject(err);
                                }
                            });
                    }
                    , (err) => {
                        if (err.status === 404) {
                            return resolve([]);
                        } else {
                            return reject(err);
                        }
                    });
            }
        });
    }
};

export {
    memberPurchase
}